import React from "react";

function SkeletonBlock({ className = "" }) {
  return (
    <div
      className={`animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10 ${className}`}
    />
  );
}

function AdherentPrepaSkeleton() {
  return (
    <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <SkeletonBlock className="h-8 w-56" />

      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <SkeletonBlock className="h-72" />
        <SkeletonBlock className="h-72" />
        <SkeletonBlock className="h-72" />
        <SkeletonBlock className="h-72" />
      </div>
    </div>
  );
}

export default AdherentPrepaSkeleton;